// import React, { useEffect, useRef, useState } from 'react';
// import { MapContainer, GeoJSON } from 'react-leaflet';
// import 'leaflet/dist/leaflet.css';
// import './Map.css';
// import L from 'leaflet';

// const Map = () => {
//   const [geoData, setGeoData] = useState(null);
//   const [stateStats, setStateStats] = useState([]);
//   const mapRef = useRef(null);

//   useEffect(() => {
//     const fetchGeoData = async () => {
//       try {
//         const [geoRes, stateRes] = await Promise.all([
//           fetch('/india.json'),
//           fetch('http://localhost:3007/api/state'),
//         ]);
//         if (!geoRes.ok || !stateRes.ok) throw new Error('Failed to load data');
//         const geo = await geoRes.json();
//         const states = await stateRes.json();
//         setGeoData(geo);
//         setStateStats(states);
//       } catch (error) {
//         console.error('Error loading data:', error);
//       }
//     };

//     fetchGeoData();
//   }, []);

//   const getPopupContent = (stateName) => {
//     const state = stateStats.find((s) => s.st_nm === stateName);
//     if (!state) return '<div class="custom-popup">No data available</div>';
//     return `
//       <div class="custom-popup">
//         <h3>${state.st_nm}</h3>
//         <ul>
//           <li><strong>Districts:</strong> ${state.district_count}</li>
//           <li><strong>Talukas:</strong> ${state.taluk_count}</li>
//           <li><strong>Villages:</strong> ${state.village_count}</li>
//         </ul>
//       </div>
//     `;
//   };
  

//   const highlightStyle = {
//     weight: 3,
//     color: '#ffcc00',
//     fillOpacity: 0.7,
//   };

//   const defaultStyle = {
//     fillColor: '#cccccc',
//     weight: 1,
//     color: 'purple',
//     fillOpacity: 0.5,
//   };

//   const onEachFeature = (feature, layer) => {
//     const stateName = feature.properties?.st_nm;
//     if (!stateName) return;
  
//     layer.setStyle(defaultStyle);
  
//     const popupContent = getPopupContent(stateName);
//     const popup = L.popup({ closeButton: false, autoPan: false })
//       .setContent(popupContent);
  
//     layer.bindPopup(popup);
  
//     layer.on({
//       mouseover: (e) => {
//         const layer = e.target;
//         layer.setStyle(highlightStyle);
//         const bounds = layer.getBounds();
//         const center = bounds.getCenter();
//         popup.setLatLng(center);
//         layer.openPopup();
//       },
//       mouseout: (e) => {
//         e.target.setStyle(defaultStyle);
//         e.target.closePopup();
//       },
//     });
//   };
  

//   return (
//     <div className="map-container">
//       <div className="map">
//         <MapContainer
//           center={[23.5, 82.6]}
//           zoom={5}
//           style={{ height: '100%', width: '100%' }}
//           dragging={false}
//           scrollWheelZoom={false}
//           doubleClickZoom={false}
//           zoomControl={false}
//           attributionControl={false}
//           whenCreated={(mapInstance) => {
//             mapRef.current = mapInstance;
//             mapInstance.setView([22.9734, 82.6], 4.5);
//           }}
//         >
//           {geoData && (
//             <GeoJSON data={geoData} onEachFeature={onEachFeature} />
//           )}
//         </MapContainer>
//       </div>

//       <div className="map-overlay">
//         <h2 className="overlay-title">
//           <span className="highlight-number">26</span> States
//         </h2>
//         <h3 className="overlay-subtitle">
//           <span className="highlight-number">760</span> Districts
//         </h3>
//         <h3 className="overlay-subtitle">
//           <span className="highlight-number">6</span> Union Territories
//         </h3>
//         <h3 className="overlay-subtitle">
//           <span className="highlight-number">8,786</span> Talukas
//         </h3>
//         <h3 className="overlay-subtitle">
//           <span className="highlight-number">15,523</span> Villages
//         </h3>
//       </div>
//     </div>
//   );
// };

// export default Map;


//with colour


import React, { useEffect, useRef, useState } from 'react';
import { MapContainer, GeoJSON } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import './Map.css';
import L from 'leaflet';

const Map = () => {
  const [geoData, setGeoData] = useState(null);
  const [stateStats, setStateStats] = useState([]);
  const mapRef = useRef(null);

  useEffect(() => {
    const fetchGeoData = async () => {
      try {
        const [geoRes, stateRes] = await Promise.all([
          fetch('/india.json'),
          fetch('https://api-insights.haqdarshak.com/api/state'),
        ]);
        if (!geoRes.ok || !stateRes.ok) throw new Error('Failed to load data');
        const geo = await geoRes.json();
        const states = await stateRes.json();
        setGeoData(geo);
        setStateStats(states);
      } catch (error) {
        console.error('Error loading data:', error);
      }
    };

    fetchGeoData();
  }, []);

  // Dynamic color scale function
  const getColor = (value) => {
    return value > 10000 ? '#4B0B8E' :   // Dark violet
           value > 5000  ? '#6D4E94' :
           value > 2000  ? '#8E73B8' :
           value > 1000  ? '#A993D1' :
           value > 500   ? '#CBB3EB' :
           value > 100   ? '#E5D3F4' :
           value > 0     ? '#F3E9FB' :   // Very light violet
                          '#F9F4FC';     // Almost white violet
  };

  const highlightStyle = {
    weight: 3,
    color: '#ffcc00',
    fillOpacity: 0.7,
  };

  const onEachFeature = (feature, layer) => {
    const stateName = feature.properties?.st_nm;
    if (!stateName) return;
  
    const state = stateStats.find((s) => s.st_nm === stateName);
    const value = state?.village_count || 0;
    const fillColor = getColor(value);
  
    const defaultStyle = {
      fillColor: fillColor,
      weight: 1,
      color: 'purple',
      fillOpacity: 0.6,
    };
  
    layer.setStyle(defaultStyle);
  
    layer.on({
      mouseover: (e) => {
        const layer = e.target;
        layer.setStyle(highlightStyle);
      },
      mouseout: (e) => {
        e.target.setStyle({
          ...defaultStyle,
          fillColor: getColor(value),
        });
      },
    });
  };

  return (
    <div className="mapbox-container">
      <div className="mapbox-map">
        <MapContainer
          center={[23.5, 82.6]}
          zoom={5}
          style={{ height: '100%', width: '100%' }}
          dragging={false}
          scrollWheelZoom={false}
          doubleClickZoom={false}
          zoomControl={false}
          attributionControl={false}
          whenCreated={(mapInstance) => {
            mapRef.current = mapInstance;
            mapInstance.setView([22.9734, 82.6], 4.5);
          }}
        >
          {geoData && (
            <GeoJSON data={geoData} onEachFeature={onEachFeature} />
          )}
        </MapContainer>
      </div>

      <div className="mapbox-overlay">
        <h2 className="mapbox-title">
          <span className="mapbox-highlight">26</span> States
        </h2>
        <h3 className="mapbox-subtitle">
          <span className="mapbox-highlight">760</span> Districts
        </h3>
        <h3 className="mapbox-subtitle">
          <span className="mapbox-highlight">6</span> Union Territories
        </h3>
        <h3 className="mapbox-subtitle">
          <span className="mapbox-highlight">8,786</span> Talukas
        </h3>
        <h3 className="mapbox-subtitle">
          <span className="mapbox-highlight">15,523</span> Villages
        </h3>
      </div>
    </div>
  );
};

export default Map;
